import script from "./ScrollingMarquee.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollingMarquee.vue?vue&type=script&setup=true&lang=js"

import "./ScrollingMarquee.vue?vue&type=style&index=0&id=02814951&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02814951"]])

export default __exports__